import { useAppSelector } from "@/redux/app/hooks";
import { useGetAllLoggedPurchaseQuery } from "@/redux/features/api/purchase/purchaseApiSlice";

const useDataPurchase = () => {
    const accessToken = useAppSelector(store => store.auth.accessToken);
    const { data: purchaseData, error, isLoading } = useGetAllLoggedPurchaseQuery<any>({}, { skip: accessToken ? false : true });
    return { purchaseData: purchaseData?.data?.purchases, errorPurchaseData: error?.data?.error?.message as string, isLoadingPurchaseData: isLoading };
}

export default useDataPurchase;